export const join = (...paths: string[]): string =>
  paths
    .filter((path) => path !== "")
    .join("/")
    .replace(/\/+/gi, "/");
